import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useAuth from 'hooks/useAuth';
import { Rights } from '../../graphql/types';

type RightsGuardProps = {
  children: ReactNode;
  oneOfRights?: Rights[];
  forbiddenRights?: Rights[];
  redirectTo?: string;
};

const RightsGuard = ({ children, oneOfRights, forbiddenRights, redirectTo = '/' }: RightsGuardProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const userRights = (user?.rights ?? []) as Rights[];

  const lacksRequired = oneOfRights && !oneOfRights.some((r) => userRights.includes(r));
  const hasForbidden = forbiddenRights && forbiddenRights.some((r) => userRights.includes(r));
  const denied = !!(lacksRequired || hasForbidden);

  useEffect(() => {
    if (denied) {
      navigate(redirectTo, { replace: true });
    }
  }, [denied, navigate, redirectTo]);

  if (denied) {
    return null;
  }

  return <>{children}</>;
};

export default RightsGuard;
